import { render, staticRenderFns } from "./DocumentBlock.vue?vue&type=template&id=e93297da"
import script from "./DocumentBlock.vue?vue&type=script&lang=js"
export * from "./DocumentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports